<template>
  <div class="container">
    <v-container class="fill-height" fluid>
      <v-row align="center" justify="center">
        <v-col cols="12" sm="8" md="4">
          <v-card class="elevation-12">
            <v-toolbar color="blue-grey darken-1" dark flat>
              <v-toolbar-title class="mx-auto">Please log in before continue</v-toolbar-title>
            </v-toolbar>

            <v-form :lazy-validation="lazy" @submit.prevent="submit">
              <v-card-text>
                <v-alert type="error" v-if="error">
                  {{error}}
                </v-alert>

                <v-text-field
                  label="Email"
                  prepend-icon="mdi-account"
                  id="email"
                  type="email"
                  name="email"
                  value
                  required
                  autofocus
                  v-model="form.email"
                  :rules="emailRules"
                ></v-text-field>

                <v-text-field
                  id="password"
                  label="Password"
                  name="password"
                  prepend-icon="mdi-lock"
                  type="password"
                  required
                  v-model="form.password"
                ></v-text-field>
              </v-card-text>

              <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn color="blue-grey darken-1" dark @click="submit" large type="submit">Login</v-btn>
              </v-card-actions>
            </v-form>
          </v-card>
        </v-col>
      </v-row>
    </v-container>
  </div>
</template>

<script>
import firebase from "firebase";

export default {
  data() {
    return {
      form: {
        email: "",
        password: "",
      },
      error: null,
      emailRules: [
        v => !!v || 'E-mail is required',
        v => /.+@.+\..+/.test(v) || 'E-mail must be valid',
      ],
      lazy: false,
    };
  },
  methods: {
    submit() {
      firebase
        .auth()
        .signInWithEmailAndPassword(this.form.email, this.form.password)
        .then((data) => {
          console.log(data);
          this.$router.replace({ name: "Manage" });
        })
        .catch((err) => {
          this.error = err.message;
        });
    },
  },
};
</script>

<style lang="scss" scoped>
.v-card__actions {
  & .v-btn.v-btn {
    padding: 0.5rem 3rem;
    position: relative;
    right: 0.25rem;
    top: -0.5rem;
  }
}
</style>